import EntityDetails from '@/agilis/components/EntityDetails/EntityDetails.vue'
import TrackerDataTableItemChildren from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableItemChildren/TrackerDataTableItemChildren.vue'
import Configuration from '@/agilis/util/Configuration'
import { mapGetters } from 'vuex'

export default {
  name: 'TrackerDataTableExpandRow',

  components: {
    EntityDetails,
    TrackerDataTableItemChildren
  },

  props: {
    configuration: Object,
    itemDTO: Object
  },

  computed: {
    ...mapGetters({
      userId: 'userDataStore/userId',
      selectedContext: 'contextStore/selectedContext',
      selectedAppConfig: 'contextStore/application',
      trackerTypeId: 'contextStore/trackerTypeId',
      trackerType: 'contextStore/trackerType'
    }),

    selectedContextWithTrackerId () {
      return Object.assign(this.selectedContext, { trackerId: this.itemDTO.id })
    },

    subtaskTitle () {
      const childrenLabel = this.trackerType.dataTableItemChildrenTitle
      return childrenLabel ? this.$t(childrenLabel) : this.$t('label.subTasks')
    },

    trackerTypeCanHaveChildren () {
      const childrenTypesArray = this.selectedAppConfig.trackerTypes[this.itemDTO?.trackerTypeId]?.childrenTypes
      return childrenTypesArray === undefined || childrenTypesArray.length > 0
    },

    showChildren () {
      return this.configuration.showChildren
    }
  },

  methods: {
    userCanAccessFeature (featureId) {
      return Configuration.auth.userCanAccessFeature(
        this.selectedContext, featureId, null, this.itemDTO, this.userId)
    }
  }
}
